<template>
  <div id="OfficeCalenderModal">
    <div class="modal-card" style="width:295px;">
      <section class="modal-card-body">
        <vc-calendar
          :first-day-of-week="1"
          @update:from-page="changePage"
        >
          <template slot="header-title" slot-scope="page">{{page.yearLabel}}年{{page.monthLabel}}</template>
          <template slot="day-content" slot-scope="props">
            <section :set="dayType = getDayType(props.day)">
              <div class="vc-border" style="widh:10px; heght:10px">
                <div style="border: 1px solid #ccc; text-align:center">
                  <div v-if="dayType == 'weekday'" :class="dayType + ' canClick'" style="border: 1px solid #ccc;" v-on:click="selectDay(props.day)" >{{ props.day.day }}</div>
                  <div v-if="dayType == 'holiday'" :class="dayType" style="border: 1px solid #ccc;" >{{ props.day.day }}</div>
                </div>
              </div>
            </section>
          </template>
        </vc-calendar>
      </section>
    </div>
  </div>
</template>
<script>
const holiday_jp = require("@holiday-jp/holiday_jp");
const philipsHolidays = require('@/components/mock/base/philipsHollday.json')
export default {
  name: "OfficeCalenderModal",
  props: {
    miniday: {},
    maxDay: {},
    disabledDays: {type: Array}
  },
  methods: {
    changePage: function(event) {
      //祝日を更新する
      var sDate = new Date(event.year, event.month -1, 1)
      var eDate = new Date(event.year, event.month, 0)
      this.holidays = holiday_jp.between(sDate,eDate);
      this.$emit('change-page',this.yyyy_hyp_MM_hyp_dd(sDate), this.yyyy_hyp_MM_hyp_dd(eDate));
    },
    getDayType: function(day){
      //最小選択可能日以前はholidayに倒す
      if(day.date < this.miniday || day.date > this.maxDay){
        return "holiday"
      }
      if (day.weekday == 1 || day.weekday == 7) {
        return "holiday"
      }
      var formatedDay = this.yyyy_hyp_MM_hyp_dd(day.date);
      for (var i in this.holidays) {
        if ( formatedDay == this.yyyy_hyp_MM_hyp_dd(this.holidays[i].date)) {
          return "holiday"
        }
      }
      //PHILIPS特別休日
      if(philipsHolidays.irregular.includes(formatedDay)){
        return "holiday"
      }
      //年末年始
      formatedDay = this.MM_hyp_dd(day.date);
      if(philipsHolidays.everyyear.includes(formatedDay)){
        return "holiday"
      }
      // 選択不可 日付指定
      if (this.disabledDays) {
        for (var disabled of this.disabledDays) {
          if ( formatedDay == disabled.date) {
            return "holiday"
          }
        }
      }

      return "weekday";
    },
    selectDay: function(day){
      this.$emit('select',this.yyyy_hyp_MM_hyp_dd(day.date));
    },
  },
  data() {
    return {
      philipsHolidays:philipsHolidays,
      holidays: [],
    };
  },
  filters: {},
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.holiday {
  background-color: lightgray;
  color: gray;
}
.canClick {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/OfficeCalenderModal.vue